import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatNativeDateModule} from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import 'moment/locale/pt-br';
import {DatePickerPadraoComponent} from '../../../../shared/components/date-picker-padrao/date-picker-padrao.component';
import {TimePickerPadraoComponent} from '../../../../shared/components/time-picker-padrao/time-picker-padrao.component';

@Component({
  selector: 'app-agendamento-disparo',
  standalone: true,
  imports: [MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule, DatePickerPadraoComponent, TimePickerPadraoComponent],
  templateUrl: './agendamento-disparo.component.html',
  styleUrl: './agendamento-disparo.component.css'
})
export class AgendamentoDisparoComponent {
  @Output() envioTempo = new EventEmitter<any>();

  @Input() dataSelecionada: any;
  @Input() horarioSelecionado: any;
  @Input() disabledData = false;
  @Input() disabledHorario = false;
  @Input() dataMinima: any;
  @Input() labelData = 'Data';

  tratarTempo(dataAlterada = false){
    const tempo = {
      data: this.dataSelecionada,
      hora: this.horarioSelecionado,
      dataAlterada
    };
    this.envioTempo.emit(tempo)
  }
}
